import { useMemo } from 'react';

import type { MessageKey } from 'src/shared/translations/translations.js';
import {
    hasLowerCaseCharValidator,
    hasNumberValidator,
    hasUpperCaseCharValidator,
    lengthValidator,
} from 'src/shared/utils/validation-rules.js';

export const usePasswordStrengthCriteria = (msgStr: (key: MessageKey, ...args: (string | undefined)[]) => string) => {
    return useMemo(
        () => [
            {
                validators: [lengthValidator],
                message: msgStr('passwordStrengthLevel1'),
            },
            {
                validators: [hasLowerCaseCharValidator],
                message: msgStr('passwordStrengthLevel2'),
            },
            {
                validators: [hasUpperCaseCharValidator, hasNumberValidator],
                message: msgStr('passwordStrengthLevel3'),
            },
            {
                validators: [],
                message: msgStr('passwordIsStrong'),
            },
        ],
        [msgStr],
    );
};
